import React from "react";
import { Container } from "react-bootstrap";
import classes from './linkBlock.module.css';

const BgBlock = () => {
    return(
        <div className={classes.bgContent}>
            <Container fluid="md">
                <h3>X-TOWER:</h3>
                <div className={classes.bgBody}>
                    <ul>
                        <li>Высота от 6 до 36 м.</li>
                        <li>До 27 секторных антенн</li>
                    </ul>
                    <ul>
                        <li>До 6-ти радиорелейных антенн Dx60 см</li>
                        <li>До 3-х операторов на вышке</li>
                    </ul>
                </div>
            </Container>
            <div className={classes.linkBlock_bg}></div>
        </div>
    )
}

export default BgBlock;